export default "__VITE_PUBLIC_ASSET__2de0e5bb__"